import { API_URL, API_KEY, FILTER_SERVICE } from '../configs/global';

export const FETCH_SERVICES = 'FETCH_SERVICES';

export const getId = (obj, index) => {
  if (!!obj && !!obj.request && !!obj.request.length && !!obj.request[index]) {
    return obj.request[index].groupId
      ? obj.request[index].groupId
      : obj.request[index].stopId;
  }
  return '';
};

export const getName = (obj, index) => {
  if (!!obj && !!obj.request && !!obj.request.length && !!obj.request[index]) {
    return obj.request[index].ticketName;
  }
  return '';
};

export const fetchServices = (
  fromId,
  toId,
  type,
  showValidationMsgs,
  history,
  cb
) => {
  let url = '';
  let fromUnix = Math.round((new Date()).getTime() / 1000) - (2 * 3600);
  let toUnix = fromUnix + (48 * 3600);
  //toUnix = Math.round(new Date(toUnix * 1000).setUTCHours(23,59,59,999) / 1000);
  if (type !== 'service')
    if (toId)
      url = `${API_URL}/public-departures-between-stops-v1/${fromId}/${toId}/${fromUnix}/${toUnix}?api_key=${API_KEY}${FILTER_SERVICE ? '&only_service_classes=' + FILTER_SERVICE : ''}`;
    else
      url = `${API_URL}/public-departures-by-stop-v1/${fromId}/${fromUnix}/${toUnix}?api_key=${API_KEY}${FILTER_SERVICE ? '&only_service_classes=' + FILTER_SERVICE : ''}`;
  else  
  url = `${API_URL}/public-origin-departures-by-route-v1/${fromId}/${fromUnix}/${toUnix}?api_key=${API_KEY}${FILTER_SERVICE ? '&only_service_classes=' + FILTER_SERVICE : ''}`;


  return (dispatch) => {
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        if (response.routes)
          response.stops = response.routes;
        if (showValidationMsgs) {
          if (response && !response.stops[0].chronological_departures.length) {
            showValidationMsgs(true);
          } else {
            showValidationMsgs(false);
            if (type === 'between')
              history.push(`/view/between/${fromId}/${toId}`);
            else if (type === 'reference')
              history.push(`/view/reference/${fromId}`);
            else if (type === 'stop') history.push(`/view/stop/${fromId}`);
            else if (type === 'service')
              history.push(`/view/service/${fromId}`);

            let recentSearches = localStorage.recentSearch;
            let arr = [];

            if (recentSearches && recentSearches.length) {
              recentSearches = JSON.parse(recentSearches);
              const duplicateSearch = recentSearches.filter(
                (search) =>
                (search.stops[0].metadata.internal_id !== response.stops[0].metadata.internal_id)
                || (response.to_stops_metadata && response.to_stops_metadata.length && response.to_stops_metadata[0].internal_id !== search.to_stops_metadata[0].internal_id)
                || (response.routes && response.routes.length && response.routes[0].metadata.route_id !== search.routes[0].metadata.route_id)
              );

              if ((duplicateSearch.length > 0)) {
                arr = duplicateSearch;
                arr.unshift(response);
              } else {
                arr.unshift(...recentSearches);
              }
              if (arr.length > 4) {
                arr.splice(-1, 1);
              }
            } else {
              arr.unshift(response);
            }

            localStorage.setItem('recentSearch', JSON.stringify(arr));
            localStorage.setItem('timestamp', new Date().getTime());
          }
        }

        if (response && response.stops[0].chronological_departures.length) {
          dispatch({
            type: FETCH_SERVICES,
            payload: response,
          });
        }

        if (cb) {
          cb(response);
        }
      })
      .catch((error) => console.log(error));
  };
};



// WEBPACK FOOTER //
// ./src/actions/ServicesAction.js